import React from 'react';
import { parsedMetaObject } from './ViewDraftjsUtils';


const ViewDraftjsText = ({ text, metadata, redirectDisabled = false, allAnchors }) => {
  if (metadata === null || !metadata || metadata === 'null') {
    return (
      <React.Fragment>
        {text}
      </React.Fragment>
    );
  }
  let metaObject = metadata;
  if (typeof metadata === 'string') {
    try {
      metaObject = JSON.parse(metadata);
    } catch (err) {
      metaObject = {};
    }
  }

  return (
    <React.Fragment>
      {parsedMetaObject(text, metaObject, redirectDisabled, allAnchors)}
    </React.Fragment>
  );
};

export default ViewDraftjsText;
